import React from 'react'

import { Translation } from 'cng-common/features/translations/components/translation'
import { Checkbox } from 'core-components/library/checkbox'

import styles from './CheckboxTranslated.module.scss'

interface IProps {
  label: string
  checked: boolean
  onChange: (flag: boolean) => void
  isIndeterminate?: boolean
}

export const CheckboxTranslated = ({ label, checked, onChange, isIndeterminate }: IProps) => {
  return (
    <div className={styles.root}>
      <Checkbox
        indeterminate={isIndeterminate}
        checked={checked}
        onChange={onChange}
        className={styles.checkBox}
      />
      <Translation text={label} />
    </div>
  )
}
